module.exports = __webpack_public_path__ + "static/media/antenista.1fad397c.png";